import { Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApplicationService, SeasonStatusResponse } from '@aifs-shared/application/application.service';
import { UserService } from '@aifs-shared/user/user.service';

@Component({
    selector: 'app-season-closed',
    templateUrl: './season-closed.component.html'
})
export class SeasonClosedComponent implements OnInit {
    private http = inject(HttpClient);
    private userService = inject(UserService);
    private application = inject(ApplicationService);

    constructor() { }

    ngOnInit(): void {
        const isApplicant = this.userService.isApplicant();

        if (isApplicant) {
            const user = this.userService.applicantRole();
            if (user) {
                const activeApplicationId = user.activeApplicationId!;
                const userState = user.state != "" ? user.state : user.nextSeasonState;
                // https://aifsdevuk.atlassian.net/browse/CA-1542
                // This affects the message to ONLY PreInterview when the country of application
                // is temporarily closed.
                if (userState == 'PreInterview') {
                    this.application.seasonOpenStatus(activeApplicationId)
                        .subscribe({
                            next: (s: SeasonStatusResponse) => {
                                this.seasonThis = s.result.season;
                                this.seasonNext = this.seasonThis + 1;
                                this.seasonTemporaryClosed = s.result.lateSeasonClosure;
                            },
                            error: (e: any) => {
                                console.error(e);
                            }
                        });
                }
            }
        }
    }

    seasonThis?: number;
    seasonNext?: number;
    seasonTemporaryClosed: boolean = false;
}
